export const formatDateTimeIST = (value) => {
  if (!value) return "";

  const date = new Date(value);

  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const get = (type) => parts.find((p) => p.type === type)?.value || "";

  return `${get("year")}-${get("month")}-${get("day")}, ${get("hour")}:${get("minute")}`;
};

export const formatDateIST = (value) => {
  if (!value) return "";

  const s = String(value);

  if (!s.endsWith("Z") && !/[+-]\d{2}:\d{2}$/.test(s)) {
    return s.split(" ")[0];
  }

  return new Date(s).toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
  });
};

export const formatTimeIST = (value) => {
  if (!value) return "";

  return new Date(value).toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};